import { abilitiesPlugin } from '@casl/vue'
import { buildAbilityFor } from '~/auth/abilities'

export default defineNuxtPlugin({
  name: 'CASL',
  async setup (nuxtApp) {
    nuxtApp.vueApp.use(abilitiesPlugin, buildAbilityFor('no-one'))
  },
})
